import { EmptyStateInApp } from 'ui/illustrations';
import { desktopDeviceStyle, emptyStateWrapper, messageUnset, mobileDeviceStyle } from './styles';
import { displayContent } from '../../common/content';
import { useInAppPreviewContext } from '../context/InAppPreviewContext';
import { IN_APP_VIEW_OPTIONS } from '../constants';

export const PreviewEmptyState = () => {
  const { previewViewOption, previewError: hasPreviewError } = useInAppPreviewContext();

  const deviceStyle =
    previewViewOption === IN_APP_VIEW_OPTIONS.inApp ? mobileDeviceStyle : desktopDeviceStyle;

  return (
    <div style={deviceStyle}>
      <div style={emptyStateWrapper}>
        <EmptyStateInApp />
        {!hasPreviewError && <div style={messageUnset}>{displayContent.strEmptyContentInApp}</div>}
      </div>
    </div>
  );
};
